
import './App.css';
import React,{useEffect,useState} from 'react'
import CategoryPage from './components/CategoryPage';
import HomePage from "./components/HomePage";
import GameDetails from './components/GameDetails';
import { BrowserRouter as Router ,Routes,Route } from 'react-router-dom';
import SearchBox from './components/SearchBox';
import Login from './components/Login';
import SubscriptionPage from './Pages/SubscriptionPage';
import OtpValidationPage from './Pages/OtpValidationPage';
import Cookies from 'js-cookie'
import {useNavigate} from 'react-router-dom'
import Subscription from './Pages/Subscription';

function App() {

  const CustomRedirect = ({ externalUrl }) => {
    const navigate = useNavigate();

    const [referrer,setReferrer] = useState('');
  
    // useEffect(() => {
    //   const user = Cookies.get('user');
    //   if (!user || user == null || user == undefined || user == " ") {
    //     Cookies.set('user','subscribed');
    //     Cookies.set('new_user_without_login','no_login',{expires:1});
    //     window.location.href = externalUrl;
    //   } 
    //   else if(user == 'subscribed') {
    //     navigate('/home')
    //   }
    // }, [navigate, externalUrl]);

    // const [queryParams,setQueryParams] = useState([]);


    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      console.log(params,'PARAMS')
      let queryParams = {};
      for (let [key, value] of params.entries()) {
        queryParams[key] = value;
      }
      // setQueryParams(queryParams);
      console.log(queryParams.ext_ref,'extref')

      if(params.size == 0 || queryParams.ext_ref == null || queryParams.ext_ref == undefined || queryParams.ext_ref == ''){
        navigate('/login')
      }
      else{
        console.log(queryParams,'dgfgcvhbjn')
        window.location.href = externalUrl;
      }
     
    }, []);

    // console.log(queryParams)


    // useEffect(() => {
    //   fetch(window.location.href)
    //     .then(response => {
    //       let headers = [];
    //       for (let [key, value] of response.headers) {
    //         headers.push(`${key}: ${value}`);
    //       }
    //       // setHeaders(headers);
    //       console.log(headers,"HEADERS")
    //     })
    //     .catch(error => {
    //       console.error('Error:', error);
    //     });
    // }, []);


    // useEffect(()=>{
    //   //check for logged in cookie
    //   const referrer = document.referrer;
    //   console.log(referrer,'Referrer_link');

    //     if (referrer){
          

    //       var referrerHostname = new URL(referrer).hostname;
    //       setReferrer(referrerHostname)
    //       console.log(`The user was referred from: ${referrerHostname}`);

    //       if(referrerHostname == 'bmd.go2oh.net'){
    //          window.location.href = externalUrl;
    //       }


    //     } else {
    //       console.log('The user accessed the site directly');
    //       const loginCookie = Cookies.get('logged_in');
    //       if(!loginCookie || loginCookie == '' || loginCookie == null || loginCookie == undefined){
    //          navigate('/login');
    //       }
    //       else{
    //         const numberCookie = Cookies.get('gameofyy_user');
    //         console.log(numberCookie)
    //         if(!numberCookie || numberCookie == '' || numberCookie == null || numberCookie == undefined){
    //           navigate('/login')
    //         }
    //         else{
    //           navigate('/home');
    //         }
    //       }
    //     }
    // },[])
  
    return null;
  };
  
  


  return (
    <div>
      <Router>
        <Routes>
        {/* <Route path="/" element={<CustomRedirect externalUrl='http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3Dew%3D%3D'/>}/> */}
          <Route path="/" element={<HomePage/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path="/otp" element={<SubscriptionPage/>}/>
          <Route path="/otp-validation" element={<OtpValidationPage/>}/>
          <Route path="/games/:gameid" element={<GameDetails/>} />
          <Route path="/category/:categoryName" element={<CategoryPage/>} /> 
          <Route path="/search" element={<SearchBox/>}/>
          <Route path='/subscribe' element={<Subscription/>}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;

  